//Temporary array created for HH Document builder migration activity .
export const HHDocBuilderDocumentTypes = ["Authorization","AdditionalInformation","NOMNC","DenialNotification"];
